define('tdfilter', ['jquery'], function ($) {

  return tdfilter = {

    classFilterUL: 'makaira-filter__list--ul',
    classFilterSearchField: 'makaira-filter__search--field',
    classFilterListItems: 'makaira-filter__item',

    filterResultsInput: function filterResultsInput() {
      var _this = this;

      var filterSearchFields = document.querySelectorAll('.' + this.classFilterSearchField);

      if (filterSearchFields.length === 0) return;

      filterSearchFields.forEach(function (searchField) {
        var filterListItems = searchField.closest('.' + _this.classFilterUL).querySelectorAll('.' + _this.classFilterListItems);

        searchField.addEventListener('keyup', function (event) {
          var self = event.currentTarget;
          var keyword = self.value.toLowerCase() || "";

          filterListItems.forEach(function (filterListItem) {
            var compareString = filterListItem.dataset.compare.toLowerCase();
            keyword.length > 0 ? compareString.indexOf(keyword) === -1 ? filterListItem.style.display = 'none' : filterListItem.style.display = 'block' : filterListItem.style.display = 'block';
          });
        });
      });
    },
    init: function init() {
      this.filterResultsInput();
    }
  };
});

